const PREFIX = 'PARTNER_OWNER_AREA_';

export const SET_IS_GROUP_MEMBERSHIP_ADDED_TO_PARTNER = `${PREFIX}SET_IS_GROUP_MEMBERSHIP_ADDED_TO_PARTNER`;
export const SET_PARTNER_NAME = `${PREFIX}SET_PARTNER_NAME`;
export const SET_PROGRAM_PAYMENT_TYPE = `${PREFIX}SET_PROGRAM_PAYMENT_TYPE`;

